import Grid from "@mui/material/Grid2";
import Stack from "@mui/material/Stack";
import DataContainer from "../../../../Utilities/DataContainer";
import RenderTextField from "../../../../Utilities/Forms/RenderTextField";
import ResidentialUnitsTable from "./ResidentialUnitsTableV1";

interface IProps {
    formContext: any;
}
export default function MonitoringReportSiteDetails({ formContext }: IProps) {

    const { getValues } = formContext;

    return (
        <Grid container size={12}>
            <Grid size={6}>
                <DataContainer title="Location">
                    <Stack spacing={1}>
                        <RenderTextField name={`description`} label={`Description`} readOnly={true} labelSize={4} inputSize={8} />
                        <RenderTextField name={`street`} label={`Street`} readOnly={true} labelSize={4} inputSize={8} />
                        <RenderTextField name={`district`} label={`District`} readOnly={true} labelSize={4} inputSize={8} />
                        <RenderTextField name={`town`} label={`Town/City`} readOnly={true} labelSize={4} inputSize={8} />
                        <RenderTextField name={`postalCode`} label={`Post Code`} readOnly={true} labelSize={4} inputSize={8} />
                        <RenderTextField name={`location`} label={`Location`} readOnly={true} labelSize={4} inputSize={8} />
                        <RenderTextField name={`subCategory`} label={`Location Sub-Category`} readOnly={true} labelSize={4} inputSize={8} />
                        <RenderTextField name={`latitude`} label={`Latitude`} readOnly={true} labelSize={4} inputSize={8} />
                        <RenderTextField name={`longitude`} label={`Longitude`} readOnly={true} labelSize={4} inputSize={8} />
                    </Stack>
                </DataContainer>
            </Grid>

            <Grid size={6}>
                <DataContainer title="On Site Parking Details">
                    <Stack spacing={1}>
                        <RenderTextField name={`parkingTotal`} label={`Total Space`} readOnly={true} labelSize={4} inputSize={8} />
                        <RenderTextField name={`parkingOnStreet`} label={`On-Street`} readOnly={true} labelSize={4} inputSize={8} />
                        <RenderTextField name={`parkingDriveways`} label={`Driveways`} readOnly={true} labelSize={4} inputSize={8} />
                        <RenderTextField name={`parkingGarage`} label={`Garages`} readOnly={true} labelSize={4} inputSize={8} />
                        <RenderTextField name={`parkingCommunal`} label={`Communal Spaces`} readOnly={true} labelSize={4} inputSize={8} />
                        <RenderTextField name={`parkingAllocated`} label={`Allocated Spaces`} readOnly={true} labelSize={4} inputSize={8} />
                        <RenderTextField name={`parkingElectric`} label={`Electric Vehicle Charging Bays`} readOnly={true} labelSize={4} inputSize={8} />
                    </Stack>
                </DataContainer>
            </Grid>

            <Grid size={6}>
                <DataContainer title="Development">
                    <Stack spacing={1}>
                        <RenderTextField name={`developmentName`} label={`Development Name`} readOnly={true} labelSize={4} inputSize={8} />
                        <RenderTextField name={`totPar1`} label={`${getValues('totPar1abbreviation')} (${getValues('totPar1Unit')})`} readOnly={true} labelSize={4} inputSize={8} />
                        <RenderTextField name={`totPar2`} label={`${getValues('totPar2abbreviation')}`} readOnly={true} labelSize={4} inputSize={8} />
                    </Stack>
                    <ResidentialUnitsTable
                        detachedPrivate={getValues("detachedPrivate")}
                        detachedNonPrivate={getValues("detachedNonPrivate")}
                        detachedTotal={getValues("detachedTotal")}
                        semiDetachedPrivate={getValues("semiDetachedPrivate")}
                        semiDetachedNonPrivate={getValues("semiDetachedNonPrivate")}
                        semiDetachedTotal={getValues("semiDetachedTotal")}
                        terracedPrivate={getValues("terracedPrivate")}
                        terracedNonPrivate={getValues("terracedNonPrivate")}
                        terracedTotal={getValues("terracedTotal")}
                        bungalowPrivate={getValues("bungalowPrivate")}
                        bungalowNonPrivate={getValues("bungalowNonPrivate")}
                        bungalowTotal={getValues("bungalowTotal")}
                        flatHousePrivate={getValues("flatHousePrivate")}
                        flatHouseNonPrivate={getValues("flatHouseNonPrivate")}
                        flatHouseTotal={getValues("flatHouseTotal")}
                        flatBlockPrivate={getValues("flatBlockPrivate")}
                        flatBlockNonPrivate={getValues("flatBlockNonPrivate")}
                        flatBlockTotal={getValues("flatBlockTotal")}
                        townhousePrivate={getValues("townhousePrivate")}
                        townhouseNonPrivate={getValues("townhouseNonPrivate")}
                        townhouseTotal={getValues("townhouseTotal")}
                        residentialUnitsOther={getValues("residentialUnitsOther")}
                    />
                </DataContainer>
            </Grid>

            <Grid size={6}>
                <DataContainer title="Changes from previous survey">
                    <RenderTextField name={`changesFromPrevious`} multiLine={true} maxRows={4} readOnly={true} />
                </DataContainer>
            </Grid>

        </Grid>
    );


}
